import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  width: 100%;
  min-height: 100%;
  pointer-events: none;
`;
